import { EPaymentMethodType } from '../types/redux/paymentMethods';

export const ANALYTICS_PAYMENT_METHODS_MAP = {
  [EPaymentMethodType.SBP]: 'Sbp',
  [EPaymentMethodType.LinkedCard]: 'Linked_card',
  [EPaymentMethodType.Others]: 'Others',
};
